import { render, staticRenderFns } from "./CompleteStep.vue?vue&type=template&id=87a457c6&scoped=true&"
import script from "./CompleteStep.vue?vue&type=script&lang=js&"
export * from "./CompleteStep.vue?vue&type=script&lang=js&"
import style0 from "./CompleteStep.vue?vue&type=style&index=0&id=87a457c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a457c6",
  null
  
)

export default component.exports